import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const washingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        addMorningEmployee: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/washing/add-ms-emp-data`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['morningEmployee', 'employee', 'washingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee")

            },

        }),
        updateMorningEmployee: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/washing/update-ms-emp-data/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['morningEmployee', 'employee', 'washingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        addEveningEmployee: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/washing/add-es-emp-data`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['eveningEmployee', 'employee', 'washingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee")

            },

        }),
        updateEveningEmployee: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/washing/update-es-emp-data/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['eveningEmployee', 'employee', 'washingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        assignEmployeForWashing: build.mutation({
            query: (requestBody) => {
                // console.log("📤 [RTK API] Request Body:", requestBody);
                return {
                    url: `/washing/assign-employees`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            // invalidatesTags: ['eveningEmployee', 'employee', 'washingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee")
            },
        }),
        updateEmployeeWork: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/washing/update-emp-work/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['updateAssignedEmployee', 'employee', 'washingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        getEmployeeData: build.query({
            query: (data) => {
                let paramData = serialize(data);

                return {
                    url: `/washing/get-employee-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['getEmployeeData'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        removeEmployeeWorkData: build.mutation({
            query: (id) => {
                return {
                    url: `/washing/${id}/delete`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Removed", "Data")
            },
            invalidatesTags: ['employees']
        }),

        getMorningEmployee: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/washing/ms-emp-logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['morningEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getEveningEmployee: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/washing/es-emp-logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['eveningEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});

export const {
    useAddEveningEmployeeMutation,
    useAddMorningEmployeeMutation,
    useGetEveningEmployeeQuery,
    useGetMorningEmployeeQuery,
    useUpdateEveningEmployeeMutation,
    useUpdateMorningEmployeeMutation,
    useAssignEmployeForWashingMutation,
    useGetEmployeeDataQuery,
    useRemoveEmployeeWorkDataMutation,
    useUpdateEmployeeWorkMutation
} = washingApi;